module.exports = __webpack_public_path__ + "media/images/static/interview/interview_4-824415d6311d6ed89d327b644cefdbd7.png";